import React from "react";
import InstructionCard from "Components/instruction_card/InstructionCard";

const HowToClaimTicketDesktop = ({ ...props }) => (
	<div className="how-to-claim-container">
		{/* <hr className="border-line" /> // uncomment when map section is enable */}

		<h3 className="how-to-claim-title">{props.firstTitle}&nbsp;<span>{props.secondTitle}</span></h3>
		<p className="how-to-claim-subtitle">{props.subtitle}</p>

		<div className="instruction-card-container">
			{
				props.instructionCard.length > 0 && props.instructionCard.map((instruction) => (
					<InstructionCard
						key={instruction.id}
						isMobile={props.isMobile}
						id={instruction.id}
						img={instruction.img}
						content={instruction.content}
					/>
				))
			}
		</div>

		<style jsx>
			{`
        h3 {
          margin: 0;
          padding: 0;
        }

        .border-line {
          border: 1px solid #F0F3F7;
        }

        .how-to-claim-container {
          font-family: 'Poppins', sans-serif;
          margin-top: ${props.marginTop};
          margin-bottom: ${props.marginBottom};
        }

        .how-to-claim-title {
          font-weight: 600;
          font-size: 24px;
          line-height: 32px;
          color: #13161A;
          margin: 72px 0px 16px 0px;
          max-width: 700px;
        }

        .how-to-claim-subtitle {
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #637381;
          max-width: 551px;
        }

				.instruction-card-container {
					width: 100%;
					margin-top: 60px;
					display: grid;
					grid-template-columns: repeat(${props.col || 5}, 1fr);
					grid-column-gap: 16px;
          grid-row-gap: 60px;
				}
      `}
		</style>
	</div>
);

export default HowToClaimTicketDesktop;
